import React, { useState } from 'react';
import { gql } from '@apollo/client';
import IdInput from 'components/Filter/IdInput';
import { BooleanField, Datagrid, BooleanInput, DateInput } from 'react-admin';
import List from 'components/List';
import PositionInput from 'components/PositionInput';
import StateInput from 'components/StateInput';
import LinkField from 'components/LinkField';
import MoneyField from 'components/MoneyField';
import DateTimeField from 'components/DateTimeField';
import { getSettingsQuery } from '../utils/getSettingsQuery';
import { SettingsNestedOperatorSelect } from 'components/SettingsNestedOperatorSelect';

const StatePositionRateSettingListFilters = [
  <IdInput />,
  <PositionInput emptyText="All" alwaysOn />,
  <StateInput label="State" source="state_id" alwaysOn resettable />,
  <BooleanInput alwaysOn source="active" />,
  <DateInput alwaysOn label="Updated after" source="search.updated_at_from" />,
];

const StatePositionRateSettingList = () => {
  const [settingsNestedOperator, setSettingsNestedOperator] = useState('ten99');

  return (
    <List filters={StatePositionRateSettingListFilters} exporter={false}>
      <SettingsNestedOperatorSelect
        setSettingsNestedOperator={setSettingsNestedOperator}
        settingsNestedOperator={settingsNestedOperator}
      />
      <Datagrid bulkActionButtons={false}>
        <LinkField label="ID" source="id" />
        <LinkField label="State" source="state.name" sortBy="state_name" />
        <LinkField label="Position" source="position.display_name" sortBy="position_name" />
        <LinkField label="Specialty" source="specialty.label" sortBy="specialty_name" />
        <MoneyField
          label="Charge 8hr Rate"
          source={`settings.${settingsNestedOperator}.charge_rate_cents`}
          blankIfNull={true}
          sortBy={`${settingsNestedOperator.replace('.', '_')}_charge_rate_cents`}
        />
        <BooleanField source="active" />
        <DateTimeField
          format="MM/dd/yyyy HH:mm"
          source="updated_at"
          timeZone="America/Los_Angeles"
        />
      </Datagrid>
    </List>
  );
};

StatePositionRateSettingList.query = gql`
  query statePositionRateSettings($input: StatePositionRateSettingQueryInput) {
    _statePositionRateSettingsMeta(input: $input) {
      count
    }
    statePositionRateSettings(input: $input) {
      id
      active
      position {
        id
        display_name
      }
      position_id
      ${getSettingsQuery()}
      specialty {
        id
        label
      }
      specialty_id
      state {
        id
        name
      }
      state_id
      state_position_rate_setting_active
      state_position_rate_setting_id
      updated_at
    }
  }
`;

export default StatePositionRateSettingList;
